import React from 'react';
import { ToolOutlined } from '@ant-design/icons';

export function ComingSoon({ title }: { title: string }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 400,
      color: '#888',
    }}>
      <ToolOutlined style={{ fontSize: 40, color: '#888', marginBottom: 12 }} />
      <div style={{ fontSize: 20, fontWeight: 600, color: '#1a1a1a', marginBottom: 6 }}>
        {title}
      </div>
      <div style={{ fontSize: 14 }}>This module is under active development.</div>
    </div>
  );
}
